
export const initProductTile = async (win) => {

    const products = [...win.document.querySelectorAll(`.product-tile`)];
    let isNz = false;
    let isMax = false;

    if (window.location.host.indexOf('.co.nz') > -1) {
        isNz = true;
    }
    products.forEach((product: HTMLElement) => {
        isMax = (window.document.querySelector("[data-user-type='MAX_USER']") && true);
        const labelText = product.getElementsByClassName('trade-only-prompt')[0];
        if(isNz && isMax) {
            if(labelText) {
                labelText.innerHTML = "Available online to trade account holders in maX";
                labelText.innerText = "Available online to trade account holders in maX";
            }
        }
    })
}



// WEBPACK FOOTER //
// ./javascript/product-search-page/product-tile/productTile.js